export function getWeekendSurchargeLineLabel(bookingData) {
  const meta = bookingData?.appliedSurchargeMeta;
  const amount = Number(bookingData?.appliedSurcharge) || 0;
  if (amount <= 0) return 'Wochenendaufschlag';
  if (!meta?.dayLabel) return 'Wochenendaufschlag';
  const { type, configValue, isPackagePricing } = meta;
  if (type === 'PERCENTAGE') {
    return `Wochenendaufschlag (${configValue}%)`;
  }
  if (isPackagePricing) {
    return `Wochenendaufschlag (${configValue}€)`;
  }
  return `Wochenendaufschlag (${configValue}€ pro Stunde)`;
}
